module.exports = __webpack_public_path__ + "img/code-summit.e0d109ea.png";